module.exports = __webpack_public_path__ + "static/assets/5325d1f816197c452ae7bcdbf8f4599b.svg";